import styled from 'styled-components';

const ClaroCard = styled.div`
    padding: ${props => props.padding ? props.padding : "1rem"};
    display: ${props => props.display ? props.display : "flex"};
    background-color: white;
    border-radius: 0.25rem;
    box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    @media (min-width: 40rem) {
          width: 50%;
    },

    @media (min-width: 56rem) {
          width: 33.3333%;
    }
`




export default ClaroCard;